<div *ngIf="displayError">
  <span class="sr-only">(error)</span>
  <div class="error-msg">
    {{ errorMsg | translate }}
  </div>
</div>
